import {Pipe, PipeTransform} from "@angular/core";
import {TranslationValue} from "../../ui-kit/dc-input-translation/dc-input-translation.component";

@Pipe({
  name: 'translationField',
  pure: true
})
export class TranslationFieldPipe implements PipeTransform {

  transform(translationsValue: TranslationValue[], showAllTranslations: boolean = false): string {
    if (!translationsValue) {
      return '';
    }

    try {
      if (!Array.isArray(translationsValue)) {
        translationsValue = JSON.parse(translationsValue);
      }

      if (showAllTranslations) {
        return translationsValue
          .map((marketingName) => `${marketingName.language} - ${marketingName.value}`)
          .join(',\n');
      }

      return (translationsValue
          .find(name => name.language.toLowerCase() === 'en')?.value
        ?? translationsValue[0]?.value) ?? '';
    } catch (e) {
      return translationsValue as unknown as string;
    }
  }
}
